import React from 'react';
import { WIDGET_ICON_MAP } from '../../../widgetIconMap';
import { formatShabbatTimeRule } from '../../shabbatZmanUtils';
import LeyningDisplay from '../../../shared/LeyningDisplay';

const Horizontal = ({ shabbat, processedCustomTimes, drashaText, loading, error, title = 'זמני שבת', showTitle = true, entryIcon = 'ShabbatCandles', exitIcon = 'MoonStar', dayEntryTime, dayExitTime, bgColor, showTimeRule = false, showEntryExit = true, shabbatLeyning, showLeyning, showHaftarah, leyningDisplayMode }) => {
  const bg = bgColor || '#f8f6f1';
  const EntryIcon = WIDGET_ICON_MAP[entryIcon] || WIDGET_ICON_MAP['ShabbatCandles'];
  const ExitIcon  = WIDGET_ICON_MAP[exitIcon]  || WIDGET_ICON_MAP['MoonStar'];

  const timeToMinutes = (t) => {
    if (!t || t === '--:--') return -1;
    const [h, m] = t.split(':').map(Number);
    return h * 60 + m;
  };

  if (loading) return <div style={{ ...S.wrap, backgroundColor: bg, justifyContent: 'center', alignItems: 'center' }}><span style={{ color: NAVY, fontSize: '18px' }}>טוען זמני שבת...</span></div>;
  if (error)   return <div style={{ ...S.wrap, backgroundColor: bg, justifyContent: 'center', alignItems: 'center' }}><span style={{ color: '#c0392b', fontSize: '16px' }}>{error}</span></div>;
  if (!shabbat) return <div style={{ ...S.wrap, backgroundColor: bg, justifyContent: 'center', alignItems: 'center' }}><span style={{ color: NAVY, fontSize: '18px' }}>אין נתוני שבת</span></div>;

  const parasha = shabbat.meta?.parsha || shabbat.parsha || 'פרשת השבוע';
  const entry   = dayEntryTime || shabbat.meta?.candleLighting || shabbat.friday?.candleLighting || '--:--';
  const exit    = dayExitTime  || shabbat.meta?.havdalah      || shabbat.shabbat?.havdalah      || '--:--';

  const allCustom = [
    ...(processedCustomTimes || []).filter(ct => (ct.day || 'friday') === 'friday').sort((a, b) => timeToMinutes(a.time) - timeToMinutes(b.time)),
    ...(processedCustomTimes || []).filter(ct => ct.day === 'shabbat').sort((a, b) => timeToMinutes(a.time) - timeToMinutes(b.time)),
  ];

  return (
    <div style={{ ...S.wrap, backgroundColor: bg }} dir="rtl">

      {/* פאנל שמאל — כניסת שבת */}
      {showEntryExit && (
        <div style={S.sidePanel}>
          <div style={S.sideIconWrap}>
            <EntryIcon style={{ width: '28px', height: '28px', color: '#fff' }} />
          </div>
          <div style={S.sideLabel}>כניסת שבת</div>
          <div style={S.sideTime}>{entry}</div>
        </div>
      )}

      {/* פאנל מרכזי */}
      <div style={S.centerPanel}>
        {showTitle && <div style={S.centerTitle}>{title}</div>}
        {shabbat.meta?.parshaShowPrefix !== false && <div style={S.centerParshaLabel}>פרשת</div>}
        <div style={S.centerParsha}>{parasha}</div>
        {shabbat.meta?.parshaSubtitle && <div style={S.centerParshaSubtitle}>{shabbat.meta.parshaSubtitle}</div>}
        {drashaText && <div style={S.centerDrasha}>{drashaText}</div>}

        {(showLeyning || showHaftarah) && shabbatLeyning && (
          <div style={{
            width: '100%',
            padding: '8px 12px',
            marginTop: '6px',
            borderTop: `1px solid rgba(30,58,95,0.15)`,
          }}>
            <LeyningDisplay
              leyning={shabbatLeyning}
              mode={leyningDisplayMode}
              showHaftarah={showHaftarah}
              showMaftir={leyningDisplayMode === 'full'}
              compact={false}
            />
          </div>
        )}

        {allCustom.length > 0 && (
          <div style={S.customBlock}>
            {allCustom.map((ct, i) => (
              <div key={i} style={S.customRow}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1px' }}>
                  <span style={S.customLabel}>{ct.label}</span>
                  {showTimeRule && formatShabbatTimeRule(ct) && (
                    <span style={{ fontSize: '10px', color: NAVY, opacity: 0.45, lineHeight: 1 }}>{formatShabbatTimeRule(ct)}</span>
                  )}
                </div>
                <span style={S.customTime}>{ct.time}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* פאנל ימין — צאת שבת */}
      {showEntryExit && (
        <div style={{ ...S.sidePanel, backgroundColor: NAVY }}>
          <div style={{ ...S.sideIconWrap, backgroundColor: 'rgba(255,255,255,0.15)' }}>
            <ExitIcon style={{ width: '28px', height: '28px', color: GOLD }} />
          </div>
          <div style={{ ...S.sideLabel, color: 'rgba(255,255,255,0.75)' }}>צאת שבת</div>
          <div style={{ ...S.sideTime, color: '#fff' }}>{exit}</div>
        </div>
      )}

    </div>
  );
};

const NAVY = '#1e3a5f';
const GOLD = '#9a7209';

const S = {
  wrap: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    boxSizing: 'border-box',
    overflow: 'hidden',
  },
  sidePanel: {
    width: '200px',
    flexShrink: 0,
    backgroundColor: GOLD,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    padding: '20px 16px',
  },
  sideIconWrap: {
    width: '52px',
    height: '52px',
    borderRadius: '50%',
    backgroundColor: 'rgba(255,255,255,0.2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '4px',
  },
  sideLabel: {
    fontSize: '14px',
    fontWeight: '700',
    color: 'rgba(255,255,255,0.85)',
    letterSpacing: '0.05em',
    textAlign: 'center',
  },
  sideTime: {
    fontSize: '44px',
    fontWeight: '800',
    color: '#fff',
    direction: 'ltr',
    lineHeight: 1,
    textShadow: '0 2px 8px rgba(0,0,0,0.2)',
    fontVariantNumeric: 'tabular-nums',
  },
  centerPanel: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px 24px',
    gap: '6px',
    borderTop: `4px solid ${GOLD}`,
  },
  centerTitle: {
    fontSize: '13px',
    fontWeight: '600',
    color: '#8a9ab0',
    letterSpacing: '0.12em',
    marginBottom: '4px',
  },
  centerParshaLabel: {
    fontSize: '13px',
    color: '#9a8f7a',
    letterSpacing: '0.1em',
  },
  centerParsha: {
    fontSize: '36px',
    fontWeight: '800',
    color: NAVY,
    textAlign: 'center',
    lineHeight: 1.2,
    marginBottom: '4px',
  },
  centerParshaSubtitle: {
    fontSize: '15px',
    fontWeight: '700',
    color: NAVY,
    opacity: 0.7,
    textAlign: 'center',
  },
  centerDrasha: {
    fontSize: '14px',
    color: '#5a6978',
    textAlign: 'center',
    fontStyle: 'italic',
    whiteSpace: 'pre-wrap',
    lineHeight: 1.4,
    marginTop: '4px',
  },
  customBlock: {
    width: '100%',
    marginTop: '10px',
    borderTop: `1px solid rgba(30,58,95,0.15)`,
    paddingTop: '10px',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  customRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    padding: '2px 0',
  },
  customLabel: {
    fontSize: '13px',
    color: '#5a6978',
  },
  customTime: {
    fontSize: '16px',
    fontWeight: '700',
    color: NAVY,
    direction: 'ltr',
  },
};

export default Horizontal;
